




























import { Vue, Component } from 'vue-property-decorator'
import VueBase from '@/lib/vuebase'
import ajax from '@/lib/ajax'
import util from '@/lib/util'
import pageRequest from '@/store/models/page-request'
@Component({})
export default class PartsRecordManager extends VueBase {
	loading: boolean = false
	finished: boolean = false
	error: boolean = false
	totalCount: number = 0
	partsRecordList: Array<any> = []
	searchForm: pageRequest = new pageRequest()

	onClickLeft() {
		window.history.go(-1)
	}

	// 页面初次加载
	async onLoad() {
		this.error = false
		this.searchForm.page += 1
		if (this.totalCount !== 0 && this.partsRecordList.length === this.totalCount) return
		await this.searchPartsRecordList()
	}
	// 查询数据
	async searchPartsRecordList() {
		await ajax
			.get('/api/partsrecord/page-list', { params: this.searchForm })
			.then((rep) => {
				this.partsRecordList.push(...rep.data.result.items)
				this.totalCount = rep.data.result.total
				if (this.partsRecordList.length === this.totalCount) this.finished = true
			})
			.catch(() => {
				this.error = false
			})
			.finally(() => {
				this.loading = false
			})
	}
}
